export default api => ({
  // register: async data => (await api.put('/readers/register',data)).data,
  // verify:   async data => (await api.post('/readers/verify', data)).data,
  signin:   async data => (await api.post('/readers/signin', data)).data,
  refresh:  async data => (await api.post('/readers/refresh',data)).data,
  update:   async data => (await api.post('/readers/update', data)).data,
})
